import React, { useEffect, useState } from "react";
import { CustomListComponent } from "../../../components/custom-list-component/CustomListComponent";
import { useSelector } from "react-redux";
import CustomDeleteButton from "../../../components/custom-delete-button/custom-delete-button";
import CustomConfirmationDialog from "../../../components/custom-confirmation-dialog/custom-confirmation-dialog";
import { deleteSession, getUserActiveSessions } from "../../../api";
import { useIntl } from "react-intl";
import CustomDataGrid from "../../../components/custom-data-grid/CustomDataGrid";

export const SessionList = () => {
  const intl = useIntl();
  const storedIdCrm = useSelector((state) => state?.idCrm);
  const storedIdUser = useSelector((state) => state?.idUser);

  const [sessionId, setSessionId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [sessions, setSessions] = useState(null);

  const confirmTitle = intl.formatMessage(
    { id: "custom.session.confirm_title" },
    {
      sessionId,
    },
  );

  const handleDialog = (id = null) => {
    setOpenDialog(!!id);
    id && setSessionId(id);
  };

  const getSessionsCallback = (data) => {
    setSessions(data);
  };

  const handleSubmit = () => {
    getUserActiveSessions(storedIdCrm, storedIdUser, getSessionsCallback);
  };

  useEffect(() => {
    if (!!storedIdUser) {
      handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDeleteResponse = () => {
    handleDialog();
    handleSubmit();
  };

  const handleDeleteSession = () => {
    deleteSession(storedIdCrm, sessionId, handleDeleteResponse);
  };

  const columns = [
    {
      field: "idCrm",
      headerName: intl.formatMessage({ id: "custom.id_crm" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "idUsuario",
      headerName: intl.formatMessage({ id: "custom.id_user" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "idLogin",
      headerName: intl.formatMessage({ id: "custom.user.login_id" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "idSesion",
      headerName: intl.formatMessage({ id: "custom.session.id" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "idDispositivo",
      headerName: intl.formatMessage({ id: "custom.devices.id" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "nombreDispositivo",
      headerName: intl.formatMessage({ id: "custom.devices.alias" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "ipInicioSesion",
      headerName: intl.formatMessage({ id: "custom.session.ip" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "fechaInicio",
      headerName: intl.formatMessage({ id: "custom.session.start_date" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "fechaUltimaActividad",
      headerName: intl.formatMessage({ id: "custom.session.last_date" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "",
      flex: 1,
      sortable: false,
      renderCell: () => {
        return <CustomDeleteButton handleOpen={handleDialog} />;
      },
    },
  ];

  return (
    <>
      <CustomListComponent
        title={intl.formatMessage({ id: "menu.session_list" })}
        handleSubmit={handleSubmit}
        setter={setSessions}
      />
      {sessions && (
        <div>
          <CustomDataGrid columns={columns} rows={sessions} getRowId={(row) => row.idSesion} />
        </div>
      )}
      <CustomConfirmationDialog
        open={openDialog}
        handleClose={handleDialog}
        handleAccept={handleDeleteSession}
        title={intl.formatMessage({ id: "custom.session.title" })}
        text={confirmTitle}
      />
    </>
  );
};
